import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "../../views/reseller/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";

import CheckPermission from "variables/CheckPermission";
import ReSellerSidebar from "components/Sidebar/ReSellerSidebar";
import NewPass from "components/Reusable Components/NewPass";
import NewEvent from "views/examples/ticketing/newGeticketsWebsite/Events";
import Cart from 'views/examples/ticketing/EventsCart'
import PastOrders from "views/reseller/PastOrders";


const ReSeller = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
  let user;
  user = JSON.parse(localStorage.getItem("user"));

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/reseller/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/reseller/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/reseller":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/reseller/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/reseller/events":
        Comp=NewEvent;
        title='Events';
        break;  
      case "/reseller/events/cart":
        Comp=Cart;
        title='Events';
        break;  
      case "/reseller/newpass":
        Comp=NewPass;
        title='Change Password';
        break;  
      case "/reseller/orders":
        Comp=PastOrders;
        title='Change Password';
        break;  
  }



  return permission ? <>
              
              <ReSellerSidebar
              pic={pic}
              logo={{
                innerLink: "/reseller/index",
                imgSrc: require("../../assets/img/brand/argon-react.png").default,
                imgAlt: "..."
              }}/>
              <div className="main-content">
                <CleanNavbar title={title}  />
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default ReSeller;
